<div style="position: relative; min-height: 20rem">
	<app-loader [showLoader]="showLoad"></app-loader>
	<div class="sem-conversions-wrapper">
		<div class="sem-conversions-chart-data">
			<div
				class="sem-conversions-chart-div {{ deviceCount }}"
				*ngFor="let config of chartConfigResponse; let i = index"
			>
				<div *ngIf="!hasData">
					<div class="map-no-data c-portlet no-data-div">{{ nodatamessage }}</div>
				</div>
				<div *ngIf="hasData">
					<app-generic-chart
						id="sem-conversions-id-{{ i }}"
						[configuration]="config"
						[colorPalette]="colorPalette"
						[data]="semConversionsChartData"
					>
					</app-generic-chart>
				</div>
			</div>
		</div>
		<div class="conversiondatatable">
			<div class="sem-coversions-class">
				<span class="sem-datatable-header">Conversions</span>
				<div *ngIf="!hasData">
					<div class="map-no-data c-portlet no-data-div">{{ nodatamessage }}</div>
				</div>
				<div *ngIf="hasData">
					<div class="sem-conversions-data" *ngFor="let semData of semConversionsTableData; let i = index">
						<div
							[ngClass]="semData.color"
							appTooltip
							[attr.title]="semData?.tooltip"
							data-size="small"
							[options]="tooltipOptions"
						>
							{{ semData.conversion_action }}
						</div>
						<span class="sem-conversiond-count"> {{ semData.conversions }}</span>
					</div>
				</div>
			</div>

			<div class="section-2">
				<div *ngIf="!hasData">
					<div class="map-no-data c-portlet no-data-div">{{ nodatamessage }}</div>
				</div>
				<div *ngIf="hasData">
					<div class="metricConversion" *ngFor="let met of metric">
						<div
							appTooltip
							class="sem-data-span"
							[attr.title]="met?.tooltip"
							data-size="small"
							[options]="tooltipOptions"
						>
							{{ met.value }}
						</div>
						<span>{{ met.name }}</span>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
